import { useSnapshot } from 'valtio';

import { authState } from '../../../services/state/auth-state.jsx';
import { campaignState } from '../../../services/state/campaign-state.jsx';
import { useQueryActiveCampaign } from '../../../hooks/queries/use-active-campaign.jsx';
import { CATALYST_USER_ROLES } from '../../../utils/constants.js';

export const BackOfficePermissionsWrapper = ({ children }) => {
  const { user } = useSnapshot(authState);
  const activeCampaign = useQueryActiveCampaign();

  const userRole = user?.details?.role;

  if (
    userRole === CATALYST_USER_ROLES.user &&
    !activeCampaign?.data?.operatorPermissions
  ) {
    return null;
  }

  return children;
};
